import { useEffect, useState } from "react";

const DarkModeToggle = () => {
  const [dark, setDark] = useState(localStorage.theme === "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.theme = dark ? "dark" : "light";
  }, [dark]);

  return (
    <button
      onClick={() => setDark(!dark)}
      className="
        px-3 py-1.5 rounded-full text-sm font-semibold
        bg-accent text-blue-900
        dark:bg-secondary dark:text-white
        hover:scale-105 transition
      "
    >
      {dark ? "☀ Terang" : "🌙 Gelap"}
    </button>
  );
};

export default DarkModeToggle;
